package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.ui.screens.active_match.StartMatchSetupViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.active_match.ActiveMatchStatsViewModel
import org.koin.dsl.module

val activeMatchUiModule = module {
    factory {
        StartMatchSetupViewModel(
            gameRepository = get(),
            playerRepository = get(),
            expansionRepository = get(),
            activeMatchController = get(),
            spotifyPlayerRepository = getOrNull(),
            lang = get()
        )
    }
    factory { ActiveMatchStatsViewModel(get(), get()) }
}
